.trail {
  display: flex;
  min-width: 0;
  flex: 1;
  container: scope-trail / inline-size;
}

.list {
  display: flex;
  min-width: 0;
  align-items: center;
  margin: 0;
  padding: 0;
  list-style: none;
}

.segment {
  display: flex;
  min-width: 0;
  flex: 0 1 auto;
  align-items: center;
}

/* The slash before every visible segment but the first. */
.separator {
  flex: 0 0 auto;
  padding: 0 0.5rem;
  color: var(--color-muted-foreground);
  font-size: 1rem;
  user-select: none;
}

.segment:first-child > .separator {
  display: none;
}

/* The trail takes the room it's given and shows as many segments as fit in it, deepest first: each
   needs about 9rem (a switcher's least width) and its slash. */
@container scope-trail (width < 30rem) {
  .segment:nth-last-child(n + 3) {
    display: none;
  }
  .segment:nth-last-child(2) > .separator {
    display: none;
  }
}

@container scope-trail (width < 19.5rem) {
  .segment:nth-last-child(n + 2) {
    display: none;
  }
  .segment:last-child > .separator {
    display: none;
  }
}
